import type {
  CreateAgentRequest,
  CreateAgentResponse,
  CreateToolRequest,
  CreateToolResponse,
  TransformedCreateAgentBody,
  TransformedCreateToolBody,
  TransformedUpdateAgentBody,
  TransformedUpdateToolBody,
  UpdateAgentRequest,
  UpdateToolRequest,
} from './agent.api.types';
import type { Agent, Tool } from './agent.types';

export const transformCreateAgentRequest = (request: CreateAgentRequest): TransformedCreateAgentBody => ({
  name: request.name,
  description: request.description,
  system_prompt: request.systemPrompt,
  dbid: request.DbID,
  project_id: request.projectID,
  organization_id: request.organizationID,
  is_private: request.isPrivate,
});

export const transformUpdateAgentRequest = (request: UpdateAgentRequest): TransformedUpdateAgentBody => ({
  name: request.name,
  description: request.description,
  system_prompt: request.systemPrompt,
  DbID: request.DbID,
  projectID: request.projectID,
  organizationID: request.organizationID,
  is_private: request.isPrivate,
});

export const transformCreateAgentResponse = (response: CreateAgentResponse): Agent => ({
  id: response.id,
  name: response.name,
  description: response.description,
  systemPrompt: response.system_prompt,
  dbID: response.dbid,
  projectID: response.project_id,
  organizationID: response.organization_id,
  createdBy: response.created_by,
  isPrivate: response.is_private,
  endpointLink: response.endpoint_link,
});

export const transformListAgentsResponse = (response: CreateAgentResponse[]): Agent[] => {
  return response.map((agent) => ({
    id: agent.id,
    name: agent.name,
    description: agent.description,
    systemPrompt: agent.system_prompt,
    dbID: agent.dbid,
    projectID: agent.project_id,
    organizationID: agent.organization_id,
    createdBy: agent.created_by,
    isPrivate: agent.is_private,
    endpointLink: agent.endpoint_link,
  }));
};

export const transformListToolsResponse = (response: CreateToolResponse[]): Tool[] => {
  return response.map((tool) => ({
    id: tool.id,
    name: tool.name,
    description: tool.description,
    agentId: tool.agent_id,
    enabled: tool.enabled,
    extraParams: {
      template: tool.extra_params.template,
      parameters: tool.extra_params.parameters.map((param) => ({
        name: param.name,
        dataType: param.data_type,
        description: param.description,
      })),
    },
  }));
};

export const transformCreateToolRequest = (request: CreateToolRequest): TransformedCreateToolBody => ({
  name: request.name,
  description: request.description,
  enabled: request.enabled,
  type: request.type,
  extra_params: {
    template: request.extraParams.template,
    parameters:
      request.extraParams.parameters?.map((param) => ({
        name: param.name,
        data_type: param.dataType,
        description: param.description,
      })) ?? [],
  },
});

export const transformCreateToolResponse = (response: CreateToolResponse): Tool => ({
  id: response.id,
  name: response.name,
  description: response.description,
  enabled: response.enabled,
  extraParams: {
    template: response.extra_params.template,
    parameters: response.extra_params.parameters.map((param) => ({
      name: param.name,
      dataType: param.data_type,
      description: param.description,
    })),
  },
});

export const transformUpdateToolRequest = (request: UpdateToolRequest): TransformedUpdateToolBody => ({
  name: request.name,
  description: request.description,
  enabled: request.enabled,
  extra_params: {
    template: request.extraParams?.template ?? '',
    parameters:
      request.extraParams?.parameters?.map((param) => ({
        name: param.name,
        data_type: param.dataType,
        description: param.description,
      })) ?? [],
  },
});
